///needs async?
export const OcpwGetAttachments = (view, layerId, attributes) => {
  const layer = view.map.allLayers
    .filter((layer) => layer.id === layerId)
    .getItemAt(0);
  const attachmentList = [];
  if (
    layer?.capabilities?.data?.supportsAttachment &&
    layer?.capabilities?.operations?.supportsQueryAttachments
  ) {
    const attachmentQuery = {
      objectIds: attributes.OBJECTID,
      //definitionExpression: "OBJECTID < 50000",
      // attachmentTypes: [
      //   "image/bmp",
      //   "image/gif",
      //   "image/svg+xml",
      //   "image/jpeg",
      //   "image/png",
      //   "image/tiff",
      //   "text/csv",
      //   "application/pdf",
      //   "application/msword",
      //   "text/plain",
      // ],
    };

    return layer
      .queryAttachments(attachmentQuery)
      .then(function (attachments) {
        if (!attachments || Object.keys(attachments).length === 0) {
          return [];
        }

        Object.keys(attachments).forEach(function (objectId) {
          const att = attachments[objectId];

          att.forEach(function (_) {
            const attachmentObj = {};

            attachmentObj["name"] = _.name;
            attachmentObj["url"] = `${_.url}`;
            attachmentObj["displayType"] = "img";

            attachmentList.push(attachmentObj);
          });
        });
        return attachmentList;
      })
      .catch(function (error) {
        console.error("There are no attachments");
      });
  } else {
  }
  return attachmentList;
};
